import { render, staticRenderFns } from "./smMessagePage.vue?vue&type=template&id=c5128a0c&scoped=true&"
import script from "./smMessagePage.vue?vue&type=script&lang=ts&"
export * from "./smMessagePage.vue?vue&type=script&lang=ts&"
import style0 from "./smMessagePage.vue?vue&type=style&index=0&id=c5128a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5128a0c",
  null
  
)

export default component.exports